export function getBaseURL() {
	if (!window.XSPORT_PUBLIC_URL.startsWith('http')) {
		if (window.cg_SYSTEM_CODE != null) {
			return  `${new URL(window.location.href).origin}`;
		} else {
			return  `${new URL(window.location.href).origin}${window.XSPORT_PUBLIC_URL}`;
		}
	}
	return window.XSPORT_PUBLIC_URL;
}
